import { API_URL, getHeaders } from "../../utils/contextHelpers";
import { api, request, buildQuery } from "./core";

export const insertarFotoFamilia = (formData) => {
    const headers = getHeaders();
    headers.delete("Content-Type");
    return request(`${API_URL}familias/foto`, {
        method: "POST",
        headers,
        body: formData,
    });
};

export const editarFotoFamilia = (formData) => {
    const headers = getHeaders();
    headers.delete("Content-Type");
    return request(`${API_URL}familias/foto/update`, {
        method: "POST",
        headers,
        body: formData,
    });
};

export const eliminarFotoFamilia = (id) =>
    api("eliminarFotoFamilia", () =>
        `${API_URL}familias/foto/delete?${buildQuery({ id })}`
    )();

export const getFotoFamilia = (familiaId) =>
    api("getFotoFamilia", () =>
        `${API_URL}familias/foto/familia?${buildQuery({ familia: familiaId })}`
    )();
